import { render, staticRenderFns } from "./AstaSelvaggia.vue?vue&type=template&id=5c9288ba&scoped=true&"
import script from "./AstaSelvaggia.vue?vue&type=script&lang=js&"
export * from "./AstaSelvaggia.vue?vue&type=script&lang=js&"
import style0 from "./AstaSelvaggia.vue?vue&type=style&index=0&id=5c9288ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9288ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c9288ba')) {
      api.createRecord('5c9288ba', component.options)
    } else {
      api.reload('5c9288ba', component.options)
    }
    module.hot.accept("./AstaSelvaggia.vue?vue&type=template&id=5c9288ba&scoped=true&", function () {
      api.rerender('5c9288ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaSelvaggia.vue"
export default component.exports